import { render, staticRenderFns } from "./ResourceFooter.vue?vue&type=template&id=68962a8c&scoped=true"
import script from "./ResourceFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResourceFooter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ResourceFooter.vue?vue&type=style&index=0&id=68962a8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68962a8c",
  null
  
)

export default component.exports